import { stopPropagation } from '../../../../../../utils/events'
import { EntityMultiValuedListMoreItem } from '../../../../../Entity'
import { useFloatingSelectContext } from '../../../../../Floating'
import { CopiedToMoreUserItem } from '../CopiedToMoreUserItem'
import { COPIED_TO_TAG_LIST_FUNCTION_BY_ENTITY } from '../CopiedToTagList.constants'
import { isCopyUserItem } from '../CopiedToTagList.utils'

import * as styles from './CopiedToTagMoreItem.module.css'

function CopiedToTagMoreItem({
  entity,
  id,
  role,
  onClick,
  onDelete,
  onMouseDown,
  ...restProps
}) {
  const { context } = useFloatingSelectContext()

  function handleClick(event) {
    onClick({ entity, event, id, role })
  }

  function handleMouseDown(event) {
    onMouseDown({ entity, event, id, role })
  }

  function handleDelete(event) {
    stopPropagation(event)

    context.setOpen(false)

    onDelete({
      event,
      getPreparedData: COPIED_TO_TAG_LIST_FUNCTION_BY_ENTITY[entity],
      id,
    })
  }

  if (isCopyUserItem(entity)) {
    return (
      <CopiedToMoreUserItem
        {...restProps}
        hoverClassName={styles.hover}
        id={id}
        role={role}
        onClick={handleClick}
        onDelete={handleDelete}
        onMouseDown={handleMouseDown}
      />
    )
  }

  // # TODO add components for other entities
  return <EntityMultiValuedListMoreItem {...restProps} onClick={handleClick} />
}

export default CopiedToTagMoreItem
